import React from "react";
import TrimbleMapsDrawControl from "@trimblemaps/trimblemaps-draw";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import Events from "../../../../../utilities/EventEmitter";
import constant from "../../../../../lib/Map/Trimble/utils/mapconstants";
import drawConstant from "./DrawConstant";
import { compose } from "recompose";
import { withMapContext } from "../../../../../lib/Map/Trimble/components/MapContext";
import { isEqual } from "lodash/lang";

class DrawingTools extends React.Component {
  constructor(props) {
    super(props);
    this.draw = null;
    this.mapId = props.useMapIdWithEvent && props.mapId ? `${props.mapId}_` : "";
    /* mapId is part of context api and will be available for all components that use DrawingTools. Pass useMapIdWithEvent to make eventName unique across different components*/
  }

  componentDidMount() {
    Events.on(
      `${this.mapId}${drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_CREATED_ON_MAP}`,
      this.resetData
    );
    const { map } = this.props;
    if (this.props.map) {
      map.on("load",this.addDrawControl);
    }
  }


  addDrawControl = () => {
    //in order to rerender drawings with colors on data load/update we need to remove the draw control and add it back when data is updated
    this.draw && this.props.map.removeControl(this.draw);
    if (this.props.map) {
      this.draw = new TrimbleMapsDrawControl({
        displayControlsDefault: false,
        userProperties: true,
        styles: this.props.styleArray,
      });
      this.props.map.addControl(this.draw, "top-left");
      this.handleAutoRecenter();
      this.refreshDrawings();
    }
  };

  refreshDrawings = () => {
    this.handleAutoRecenter();
    this.setDrawObject();
    this.addPolygon();
  };

  handleAutoRecenter = () => {
    if (!this.props.disableAutoRecenter) {
      // FIXME: Temporary fix for terminal onboarding to prevent map from recentering to the default terminal instead of the selected one.
      // The code below can be removed, but doing so causes the map to not recenter to the default terminal when switching terminals in some cases.
      // Root cause needs to be identified, along with the reason this code was originally added, before safely removing this fix.

      // Restore the map's state, TODO: Map transition is not smooth can be fixed later
      this.props.map.setCenter(
        this.props.mapCenter || this.props.userData.userProfile.terminal.location
      );
    }
  };

  checkIfDataChanged = (prevProps) => {
    if(this.props.geoDataList.length ===0 && prevProps.geoDataList.length ===0) {
      //isEqual([], []) correctly returns true, so updates won’t fire when both are empty arrays.
      //handling this manually with additional conditions.
      return true
    }
    return !isEqual(this.props.geoDataList, prevProps.geoDataList);
  }

  componentDidUpdate(prevProps) {
    if (this.props.singleColorDraw) {
      if(!this.draw) {
        this.addDrawControl();
      }
      if (!isEqual(this.props.geoDataList,prevProps.geoDataList)) {
        this.addPolygon();
      }
      return;
    }

    if (
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id ||
      this.checkIfDataChanged(prevProps) ||
      (this.props.mode && this.props.mode !== prevProps.mode)
    ) {
      const stylesUnchanged = isEqual(this.props.styleArray, prevProps.styleArray);
      if (this.draw && stylesUnchanged) {
        this.refreshDrawings();
      } else {
        this.addDrawControl();
      }
    }
  }

  componentWillUnmount() {
    Events.off(
      `${this.mapId}${drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_CREATED_ON_MAP}`,
      this.resetData
    );
     this.props.map?.off("load", this.addDrawControl);
  }

  resetData = (actionType, isExistingFeature, featureId) => {
    //this method restores the drawing to its original state when user cancels the changes.
    if (actionType === "cancel") {
      isExistingFeature ? this.handleUpdate() : this.draw.delete(featureId);
    }
  };

  handleUpdate = () => {
    this.addPolygon();
  };

  addPolygon = () => {
    if (this.props.geoDataList && this.draw) {
      this.draw.set({
        type: "FeatureCollection",
        features: this.props.geoDataList,
      });
    }
  };

  setDrawObject = () => {
    this.props.eventHub &&
      this.props.eventHub.emit(`${this.mapId}${constant.EVENT.SET_MAP_DRAW}`, {
        map: this.props.map,
        draw: this.draw,
        drawComplete: this.props.onDrawingComplete,
      });
  };

  render() {
    return null;
  }
}

export default compose(withUserProfile, withMapContext)(DrawingTools);
